// BadgeToast — promoted from learner-app/components/gamification
// to @flowgenix/shared-ui (Phase 2 / Step C-3.3).
//
// Sub-component used by `gamification_progress` and `session_player`.
// react-i18next is a static import; gracefully degrades to the i18next
// default `t` (key-as-text) when no I18nextProvider is mounted.
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './BadgeToast.css';

export default function BadgeToast({ badges, onDismiss }) {
  const { t } = useTranslation('session');
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!badges || badges.length === 0) return;
    const timer = setTimeout(() => {
      setVisible(false);
      if (onDismiss) onDismiss();
    }, 5000);
    return () => clearTimeout(timer);
  }, [badges, onDismiss]);

  if (!badges || badges.length === 0 || !visible) return null;

  return (
    <div className="badge-toast-overlay">
      {badges.map((badge, i) => (
        <div key={badge.badge_id || i} className="badge-toast-card">
          <div className="badge-toast-icon">&#127942;</div>
          <div className="badge-toast-content">
            <span className="badge-toast-label">{t('badge_earned', 'Badge Earned!')}</span>
            <span className="badge-toast-name">{badge.badge_id}</span>
            {badge.domain && <span className="badge-toast-domain">{badge.domain}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

BadgeToast.displayName = 'BadgeToast';
